export default {
  bind(el) {
    el.addEventListener('click', selectContent, false);
  },

  unbind(el) {
    el.removeEventListener('click', selectContent, false);
  },
};

export function selectContent(e) {
  const el = e.target;

  if (['textarea', 'input'].includes(el.nodeName.toLowerCase())) {
    el.focus();
    el.setSelectionRange(0, 9999);
    return;
  }

  const selection = window.getSelection();
  const range = document.createRange();

  range.selectNodeContents(el);

  selection.removeAllRanges();
  selection.addRange(range);
}
